// src/pages/BESSSetup.jsx
import { useState } from "react";
import { Box, Snackbar, Alert } from "@mui/material";
import BESSForm from "../components/BESSForm";
import { useEngine } from "../context/EngineContext";

export default function BESSSetup() {
  const [snack, setSnack] = useState({ open: false, msg: "", sev: "info" });
  const { setConfig } = useEngine();

  const handleSave = async (config) => {
    setConfig(config); 
  };

  return (
    <>
      {/* FULL WIDTH WRAPPER */}
      <Box sx={{ width: "100%", px: 0, mx: 0 }}>
        <BESSForm onSubmit={handleSave} />
      </Box>

      <Snackbar
        open={snack.open}
        autoHideDuration={2500}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snack.sev} variant="filled" sx={{ width: "100%" }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </>
  );
}
